import React from 'react';
import _get from 'lodash/get';
import VisualNav from 'yoda-core-components/lib/components/VisualNav/VisualNav';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import classNames from 'classnames/bind';
import RevieveModal from '../../../components/Revieve/RevieveModal';
import RichText from '../../../components/RichText/RichText';
import * as styles from './VisNav.css';

const cx = classNames.bind(styles);

export const massageProps = (props, preferences) => {
    const massagedData = [];
    /* istanbul ignore next */
    if (props && props.items) {
        const itemsArr = props.items;
        itemsArr.forEach((value) => {
            let itemObj = {};
            const {
                linkText: title = '',
                image: imageUrl = '',
                link: linkUrl = '',
                analyticsTag = '',
                openInNewTab = false,
            } = value;
            let { url: image = '' } = imageUrl;
            const { altText = '' } = imageUrl;
            const { url: links = '' } = linkUrl;
            const ext = checkUrlExtension(value.image.url);
            image = replaceSubdomain(image, preferences);
            itemObj = { title, image, links, analyticsTag, openInNewTab, ext, altText };
            massagedData.push(itemObj);
        });
    }
    return massagedData;
};

/* istanbul ignore next */
export const renderTheme = (
    pageType,
    exclusions = [],
    enableRndVizNav,
    enableConfigurableVisualNav,
    isMicrositeIncluded
) => {
    let themeName = 'visualNavList';
    const enableRndVizNavTheme = enableRndVizNav && exclusions.indexOf(pageType) === -1;
    if (enableConfigurableVisualNav && enableRndVizNavTheme && isMicrositeIncluded) {
        themeName = ['visualNavList', 'roundedTheme', 'roundedThemeNoBorder'];
    } else if (enableRndVizNavTheme) {
        themeName = 'roundedTheme';
    }
    return themeName;
};
/* istanbul ignore next */
export const alignmentTheme = (props = {}) =>
    props.theme &&
    (props.theme.large === 'headline-left' || props.theme.compact === 'headline-above');

/* istanbul ignore next */
export const applyVizNavTheme = (props = {}, deviceType = {}) =>
    props.theme && (deviceType.isMobile ? props.theme.compact : props.theme.large);

export const enableSlider = (props) => {
    return props.style === 'classic';
};

const componentRendered = (props) => {
    const {
        title,
        headline,
        subHeadline,
        pageType,
        deviceType,
        preferences,
        automationId,
        featureFlags,
        displayFormat = 'stacked',
        style = 'classic',
    } = props;

    const {
        enableConfigurableVisualNav = false,
        enableRndVizNav = true,
        enableJetloreVizNav = false,
    } = featureFlags;

    const datasource = massageProps(props, preferences);
    const isMicrositeIncluded = preferences?.configurableVisNavInclusionList?.includes(pageType);

    const scrollableVisNavConditions =
        enableConfigurableVisualNav &&
        isMicrositeIncluded &&
        displayFormat === 'scrollable' &&
        style === 'classic';

    const shouldRenderScrollableVisualNav =
        (scrollableVisNavConditions && !deviceType.isMobile && datasource.length >= 7) ||
        (scrollableVisNavConditions && deviceType?.isMobile && datasource.length > 3);

    const commonProps = {
        automationId: automationId || 'visualnav',
        revieveModal: RevieveModal,
        datasource,
        enableCarouselSlider: enableSlider(props),
    };

    const stackedVisualNavProps = {
        pageName: pageType,
        departmentTitle: title,
        headline: <RichText text={headline} />,
        subHeadline: <RichText text={subHeadline} />,
        deviceType: props.deviceType,
        navTitle: '',
        isFindstoreTheme: alignmentTheme(props),
        vizNavFasCustomTheme: applyVizNavTheme(props, deviceType),
        navTheme: renderTheme(
            pageType,
            _get(preferences, 'rndVisNavXs', []),
            enableRndVizNav,
            enableConfigurableVisualNav,
            isMicrositeIncluded
        ),
        enableJetloreVizNav,
    };

    const scrollableVisualNavConfig = {
        props: {
            galleryTheme: {
                deptTitle: `${dt(['pt-2', 'text-black'])} ${cx('department-title')}`,
                imgBlock: `${dt([
                    'w-full',
                    'sm:!pb-[100%]',
                    'relative',
                    'sm:!min-h-0',
                    '!pt-0',
                ])} ${cx('image-block')}`,
                visualNavComponent: cx('visualNavComponent', dt(['border-none', 'pb-1'])),
            },
            themeConfig: {
                gridTilesList: `${cx('grid-tiles-list')}`,
                visNavDeptTitle: `${dt(['pt-2', 'text-black'])} ${cx('department-title')}`,
                visNavGridTilesClass: `${dt([
                    'flex-no-wrap',
                    'inline-flex',
                    'items-baseline',
                    'min-w-full',
                    `${shouldRenderScrollableVisualNav ? '!items-start' : 'justify-center'}`,
                ])} ${cx('grid-tiles')}`,
                visNavGridTilesList: true,
            },
            visualNavBodyClass: dt(['text-center']),
            vizNavTheme: 'styleB',
        },
        wrapper: {
            className: `${dt(['overflow-hidden'])} ${cx('visnav-custom-wrapper')} scrollableStyles`,
            'data-whoami': 'visNav-coreZones',
        },
    };

    return shouldRenderScrollableVisualNav ? (
        <div {...scrollableVisualNavConfig.wrapper}>
            <VisualNav {...commonProps} {...scrollableVisualNavConfig.props} />
        </div>
    ) : (
        <VisualNav {...commonProps} {...stackedVisualNavProps} />
    );
};

export default (props) => {
    return componentRendered(props);
};
